/**
 * The LevelKind registry — the ONLY place kinds are enumerated (TDD §2.2). Nothing
 * downstream hardcodes a kind; adding one = `registerKind(...)`, touching no other code.
 */
import type { LevelKind } from './types.js';

const KINDS = new Map<string, LevelKind<unknown>>();

/** Register a kind. Throws on a duplicate id. */
export function registerKind<T>(kind: LevelKind<T>): void {
  if (KINDS.has(kind.id)) {
    throw new Error(`LevelKind already registered: ${kind.id}`);
  }
  KINDS.set(kind.id, kind as unknown as LevelKind<unknown>);
}

/** Look up a kind by id. Throws on an unknown id. */
export function getKind(id: string): LevelKind<unknown> {
  const kind = KINDS.get(id);
  if (!kind) {
    throw new Error(`Unknown LevelKind: ${id}`);
  }
  return kind;
}

export function listKinds(): readonly LevelKind<unknown>[] {
  return [...KINDS.values()];
}

/** Test-only: clear the registry. */
export function __clearKinds(): void {
  KINDS.clear();
}
